import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function   Navimumbaicorporatecabservice() {



  const cardData = {
    keyword: " Navi Mumbai Corporate Cab Service  ",


"headingDescription": "Royal Route Cab offers premium Navi Mumbai corporate cab service, providing reliable, punctual, and professional transportation solutions for businesses, companies, and executives. Our corporate cab services are designed for employee transportation, client pickups, airport transfers, business meetings, daily office commute, and intercity corporate travel. We ensure a high standard of service with well-maintained vehicles, trained chauffeurs, and seamless booking management tailored to corporate needs. Our fleet includes hatchbacks, sedans, SUVs, Innova, Ertiga, Kia Carens, Innova Crysta, and Tempo Travellers suitable for small teams to large employee groups. With 24/7 availability, monthly billing options, dedicated account support, and transparent pricing, Royal Route Cab is a trusted choice for corporate cab service in Navi Mumbai.",

"topPlaces": [
  {
    "title": "Employee Transportation Service",
    "description": "Corporate employee transportation service in Navi Mumbai ensures safe and timely pickup and drop for staff members across shifts. It is widely used by IT companies, manufacturing units, BPOs, and corporate offices in areas like Vashi, Nerul, Belapur, Airoli, and MIDC zones. The service helps companies reduce employee travel stress, improve punctuality, and manage workforce mobility efficiently with dedicated routes and scheduled timings."
  },
  {
    "title": "Daily Office Commute Solutions",
    "description": "Daily office commute cab service is ideal for professionals traveling regularly between home and workplace. It offers fixed routes, consistent timing, and comfortable vehicles for stress-free travel. This service helps employees avoid public transport delays and ensures a productive start and end to their workday, especially for long-distance commuters within Navi Mumbai and nearby regions."
  },
  {
    "title": "Airport Pickup & Drop for Executives",
    "description": "Corporate airport cab service ensures smooth and professional pickup and drop for executives, clients, and business guests at Mumbai and Navi Mumbai airports. Drivers track flight schedules in real time to ensure timely arrivals and departures. Premium vehicles like Innova Crysta and Kia Carens are commonly used to provide a comfortable and executive-class travel experience."
  },
  {
    "title": "Client & Business Meeting Travel",
    "description": "Corporate cab services are widely used for client meetings, business visits, and inter-office travel. Professional chauffeurs ensure punctuality and smooth navigation across Mumbai and Navi Mumbai business districts. Clean and well-maintained vehicles provide a professional impression, making it suitable for high-level corporate engagements."
  },
  {
    "title": "Monthly Corporate Cab Packages",
    "description": "Many companies prefer monthly corporate cab packages for predictable and cost-effective transportation management. These packages include fixed billing, dedicated vehicles, and priority service. It helps organizations streamline travel expenses while ensuring reliable transport availability for employees and executives throughout the month."
  },
  {
    "title": "Intercity Corporate Travel",
    "description": "Corporate cab service also includes intercity travel to Pune, Nashik, Surat, Goa, and other business hubs. It is ideal for site visits, client meetings, and corporate events. Comfortable long-distance vehicles ensure executives can travel efficiently while maintaining productivity during journeys."
  },
  {
    "title": "Dedicated Fleet for Companies",
    "description": "Companies can opt for a dedicated fleet of vehicles based on their workforce size and travel needs. This includes hatchbacks for small teams, sedans for executives, SUVs for groups, and Tempo Travellers for larger employee transportation requirements. Dedicated fleets ensure consistency and reliability in daily operations."
  },
  {
    "title": "24/7 Corporate Support",
    "description": "Corporate cab services operate round the clock to support businesses with early morning shifts, late-night schedules, and emergency travel requirements. Dedicated support teams ensure quick response, ride tracking, and seamless coordination for uninterrupted corporate mobility."
  },
  {
    "title": "Safe & Professional Chauffeurs",
    "description": "All corporate cab services are handled by verified and professionally trained chauffeurs who understand corporate etiquette and route management. They ensure safe driving, punctual arrivals, and courteous behavior, making business travel smooth and reliable for employees and executives."
  },
  {
    "title": "Transparent Billing & Reporting",
    "description": "Corporate cab services include transparent billing systems with detailed travel reports, monthly invoices, and expense tracking. This helps companies manage transportation budgets efficiently while maintaining clarity and accountability in travel expenses."
  }
],






services: [
  {
    name: "Corporate Cab Service in Navi Mumbai",
    description: "Corporate cab service in Navi Mumbai offers professional and reliable transportation for businesses of all sizes. Ideal for employee travel, client meetings, and corporate events, this service ensures punctual pickups and comfortable rides. Well-maintained vehicles and trained drivers enhance efficiency. It guarantees a seamless corporate travel experience."
  },
  {
    name: "Corporate Taxi Service Navi Mumbai",
    description: "Corporate taxi service Navi Mumbai provides dependable travel solutions for office staff and executives. This service ensures timely transportation with flexible booking options. Comfortable vehicles enhance productivity during travel. It guarantees reliability and convenience."
  },
  {
    name: "Corporate Car Rental Navi Mumbai",
    description: "Corporate car rental Navi Mumbai offers flexible rental options for businesses needing regular or occasional transport. Companies can choose from sedans, SUVs, and premium cars. Clean vehicles and professional drivers ensure comfort. It guarantees efficient corporate mobility."
  },
  {
    name: "Corporate Cab Booking Navi Mumbai",
    description: "Corporate cab booking Navi Mumbai allows businesses to reserve cabs easily with instant confirmation. Companies can schedule pickups, assign routes, and manage employee transport efficiently. Transparent pricing ensures trust. It simplifies corporate travel planning."
  },
  {
    name: "Navi Mumbai Office Cab Service",
    description: "Navi Mumbai office cab service provides daily pickup and drop solutions for employees. Ideal for IT companies, corporate parks, and offices. Fixed schedules ensure punctuality. It guarantees safe and reliable staff transportation."
  },
  {
    name: "Corporate Travel Cab Navi Mumbai",
    description: "Corporate travel cab Navi Mumbai offers comfortable and professional travel for business trips and client visits. Experienced drivers ensure smooth journeys. Flexible booking enhances convenience. It guarantees efficient travel."
  },
  {
    name: "Business Travel Cab Navi Mumbai",
    description: "Business travel cab Navi Mumbai provides premium travel solutions for executives and professionals. Comfortable vehicles and punctual service enhance productivity. It ensures a seamless travel experience."
  },
  {
    name: "Company Cab Service Navi Mumbai",
    description: "Company cab service Navi Mumbai offers reliable transportation for employee commute and official travel. This service ensures safety, punctuality, and comfort. It guarantees smooth business operations."
  },
  {
    name: "Corporate Chauffeur Service Navi Mumbai",
    description: "Corporate chauffeur service Navi Mumbai provides trained drivers for executive travel. Ideal for VIP clients and senior management. Professional chauffeurs ensure safe and smooth rides. It guarantees a premium travel experience."
  },
  {
    name: "Corporate Transportation Navi Mumbai",
    description: "Corporate transportation Navi Mumbai offers end-to-end travel solutions for companies including employee pickup, airport transfers, and event travel. Flexible scheduling enhances efficiency. It guarantees reliable service."
  },
  {
    name: "Corporate Cab Hire Navi Mumbai",
    description: "Corporate cab hire Navi Mumbai provides flexible vehicle hiring options for businesses. Suitable for daily operations and special events. Clean vehicles and trained drivers ensure comfort. It guarantees dependable travel."
  },
  {
    name: "Corporate Taxi Booking Navi Mumbai",
    description: "Corporate taxi booking Navi Mumbai enables easy reservation of cabs for business travel. Instant confirmation and flexible scheduling ensure convenience. It simplifies corporate travel management."
  },
  {
    name: "Corporate Car Hire Navi Mumbai",
    description: "Corporate car hire Navi Mumbai offers professional vehicle rental services for executives and employees. Customers can choose from multiple vehicle options. Comfortable rides enhance productivity. It guarantees a reliable experience."
  },
  {
    name: "Corporate Employee Cab Service Navi Mumbai",
    description: "Corporate employee cab service Navi Mumbai ensures safe and timely pickup and drop for staff. Ideal for daily commuting and shift-based travel. Professional drivers ensure safety. It guarantees reliable employee transportation."
  },
  {
    name: "Corporate Cab Service Near Navi Mumbai",
    description: "Corporate cab service near Navi Mumbai provides quick and accessible travel solutions for nearby business hubs. Ideal for office travel and meetings. It ensures convenience and reliability."
  },
  {
    name: "Book Corporate Cab Navi Mumbai",
    description: "Book corporate cab Navi Mumbai with easy online booking and instant confirmation. Businesses can manage travel schedules efficiently. Transparent pricing ensures trust. It simplifies corporate travel planning."
  }
],

tableData: [
  ["Corporate Cab Service in Navi Mumbai", "Corporate Taxi Service Navi Mumbai"],
  ["Corporate Car Rental Navi Mumbai", "Corporate Cab Booking Navi Mumbai"],
  ["Navi Mumbai Office Cab Service", "Corporate Travel Cab Navi Mumbai"],
  ["Business Travel Cab Navi Mumbai", "Company Cab Service Navi Mumbai"],
  ["Corporate Chauffeur Service Navi Mumbai", "Corporate Transportation Navi Mumbai"],
  ["Corporate Cab Hire Navi Mumbai", "Corporate Taxi Booking Navi Mumbai"],
  ["Corporate Car Hire Navi Mumbai", "Corporate Employee Cab Service Navi Mumbai"],
  ["Corporate Cab Service Near Navi Mumbai", "Book Corporate Cab Navi Mumbai"]
],


whychoose: [
  {
    WhyChooseheading: "Professional Corporate Cab Service in Navi Mumbai",
    WhyChoosedescription: "Royal Route Cabs offers reliable corporate cab services in Navi Mumbai for employee transportation, client visits, and business travel."
  },
  {
    WhyChooseheading: "Experienced & Trained Drivers",
    WhyChoosedescription: "Our drivers are well-trained, punctual, and experienced in handling corporate travel requirements across Navi Mumbai and Mumbai."
  },
  {
    WhyChooseheading: "Flexible Corporate Travel Solutions",
    WhyChoosedescription: "We provide customized cab solutions including daily office pickup-drop, shift-based transport, and event-based corporate travel."
  },
  {
    WhyChooseheading: "Transparent Billing & Pricing",
    WhyChoosedescription: "Royal Route Cabs offers clear pricing and corporate billing with no hidden charges, making expense management easy for companies."
  },
  {
    WhyChooseheading: "24/7 Cab Availability for Offices",
    WhyChoosedescription: "Our corporate cab service operates round the clock, ideal for IT companies, BPOs, and night shift employees."
  },
  {
    WhyChooseheading: "Clean & Well-Maintained Fleet",
    WhyChoosedescription: "All vehicles are regularly serviced, sanitized, and maintained to ensure comfort and safety for employees and clients."
  },
  {
    WhyChooseheading: "Wide Range of Vehicle Options",
    WhyChoosedescription: "We offer sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta, Tempo Travellers, and mini buses for corporate groups."
  },
  {
    WhyChooseheading: "Trusted Corporate Travel Partner",
    WhyChoosedescription: "Royal Route Cabs is trusted by companies in Navi Mumbai for reliable, punctual, and professional corporate cab services."
  }
]

};

const faqData = [
  { question: "Do you provide corporate cab services in Navi Mumbai?", answer: "Yes, Royal Route Cabs offers corporate cab services for companies across Navi Mumbai." },
  { question: "What types of corporate services do you provide?", answer: "We provide employee transport, airport transfers, client visits, and event-based travel solutions." },
  { question: "Is cab service available 24 hours?", answer: "Yes, our corporate cab service operates 24/7 including night shifts." },
  { question: "Do you provide monthly packages?", answer: "Yes, we offer flexible monthly and long-term corporate packages." },
  { question: "Which vehicles are available?", answer: "We offer sedan cars, SUVs like Ertiga and Innova, Innova Crysta, Tempo Travellers, and mini buses." },
  { question: "Is pricing transparent?", answer: "Yes, we provide clear billing with no hidden charges." },
  { question: "Do you provide airport pickup for corporate clients?", answer: "Yes, we offer airport transfers for employees and business guests." },
  { question: "Are drivers professional?", answer: "Yes, all drivers are trained, verified, and experienced for corporate travel." },
  { question: "Do you provide doorstep pickup?", answer: "Yes, we provide pickup and drop from office, home, and airport locations." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly for safety." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Kunal Shah",
    feedback:
      "We use Royal Route Cabs for corporate travel in Navi Mumbai. Very reliable and professional service.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Ritu Mehta",
    feedback:
      "Excellent corporate cab service. On-time pickups and clean vehicles for our employees.",
    rating: 5
  }
];







  const Images = [
    { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
    { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
    { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
    { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
    { place: "/images/keyword/5.jpg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
    { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
    { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
    { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
    { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
    { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
    { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
    { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
    { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
    { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
    { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran cab", link: "Mumbai-to-Matheran-Cab" },
    { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
    { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
    { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
    { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
    { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
    { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
    { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
    { place: "/images/keyword/24.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
    { place: "/images/keyword/25.jpg", text: "Mumbai to Daman taxi", link: "Mumbai-to-Daman-Taxi" },
    { place: "/images/keyword/26.jpg", text: "Mumbai to Vapi cab", link: "Mumbai-to-Vapi-Cab" },
    { place: "/images/keyword/27.jpg", text: "Mumbai to Bangalore cab", link: "Mumbai-to-Bangalore-Cab" }
  ];








const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Navi Mumbai Corporate Cab Service",
  "image": "https://www.royalroutecabs.com/assets/images/navi-mumbai-corporate-cab-service.jpg", // replace if needed
  "description": "Book Navi Mumbai Corporate Cab Service with Royal Route Cabs for reliable business travel, employee transportation, office commute, and executive chauffeur-driven taxi solutions. Available 24x7 with sedan, SUV, Innova, and premium cars for corporate clients.",
  "brand": {
    "@type": "Brand",
    "name": "Royal Route Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.8",
    "ratingCount": "2100",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Contact for pricing",
    "availability": "https://schema.org/InStock",
    "url": "https://www.royalroutecabs.com/navi-mumbai-corporate-cab-service"
  }
};




  return (
    <div>
<Helmet>
  <title>Navi Mumbai Corporate Cab Service | Call:- +91 9529877342 | Best Outstation Cab Service</title>

  <meta
    name="description"
    content="Book Corporate Cab Service in Navi Mumbai with Royal Route Cabs. Reliable business travel, office commute, and corporate taxi solutions with professional chauffeurs and premium vehicles."
  />

  <meta
    name="keywords"
    content="corporate cab service in navi mumbai, corporate taxi service navi mumbai, corporate car rental navi mumbai, corporate cab booking navi mumbai, navi mumbai office cab service, corporate travel cab navi mumbai, business travel cab navi mumbai, company cab service navi mumbai, corporate chauffeur service navi mumbai, corporate transportation navi mumbai, corporate cab hire navi mumbai, corporate taxi booking navi mumbai, corporate car hire navi mumbai"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



      <div
        className="breadcrumb-wrapper section-padding bg-cover"
        style={{ backgroundImage: "url('/img/breadcrumb-bg.jpeg')" }}
      >
        <div className="container-fluid">
          <div className="page-heading">
            <h1 className="text-center">{cardData.keyword}</h1>
          </div>
        </div>
      </div>














      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/108.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Royal Route Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


          <div className="keyword-grid">
  {cardData.tableData.flat().map((keyword, index) => (
    <div key={index} className="keyword-item">
      <span className="keyword-bullet">-</span>
      {keyword}
    </div>
  ))}
</div>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title text-white">
                  Why Choose <span>Royal Route Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Royal Route Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919529877342" className="pc-call">+91 9529877342</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919529877342"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919529877342" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@royalroutecabs.com" className="pc-email">
                      booking@royalroutecabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Royal Route Cab</strong><br />
                      Shop Number 57, Prabhat Colony Opp. Panbai International School Vimladevi Road,Santacruz(E) Mumbai Maharashtra-400055.


                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Navimumbaicorporatecabservice;